import { colors } from '@insurancemenu/imenu-components-lib';
import { createUseStyles } from 'react-jss';

const styles = {
  selectionPanel: {
    display: 'flex',
    gap: '2rem',
    width: '93%',
    marginBottom: 0,
    justifyContent: 'center',
    paddingTop: '2rem',
  },
  sectionGuideline: {
    margin: 0,
    textAlign: 'center',
    fontSize: '1.4rem',
    color: colors.neutral[700],
  },
  attributesSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '5rem',
    padding: '0 4rem',
    marginTop: '3rem',
    opacity: 1,
    overflow: 'hidden',
    transition: '0.3s ease',
    width: '100%',
    boxSizing: 'border-box',
  },
  readyTemplateAttributesSection: {
    padding: '0 4rem 1rem',
  },
  closedAttributesSection: {
    opacity: 0,
    maxHeight: 0,
    marginTop: 0,
    transition: '0.3s ease',
  },
  attributeSelectionBlock: {
    display: 'grid',
    gridTemplateColumns: '5rem 1fr',
    gap: '2.5rem',
    alignItems: 'center',
  },
  selectionStatusCheckbox: {
    '& svg': { width: '2.5rem' },
  },
  attributesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: '4rem',
    width: '100%',
  },
};

const createStyles = createUseStyles(styles);
export { createStyles };
